import * as api from '../lib/api';
import { makeGrowerPath } from '../lib/api/utils';

export function generate(fields, options) {
  return api.post(makeGrowerPath('/elevation'), {
    aaids: fields.map((aaid) => aaid),
    ...options,
  });
}
